import { IconNames } from 'atoms/Icon'

export const NotificationToastType = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
} as const
export type NotificationToastType =
  (typeof NotificationToastType)[keyof typeof NotificationToastType]

export interface INotificationToast {
  id: string
  message: string
  type?: NotificationToastType
  duration?: number
  icon?: IconNames
}
